<template>
  <section class="spotify-section">
    <div class="container">
      <div class="spotify-bg" id="spotifyBg">
        <img
          :src="require('@/assets/image/spotify-section/sphere_blue.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__1">
        <img
          :src="require('@/assets/image/spotify-section/sphere_yellow.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__2">
        <img
          :src="require('@/assets/image/spotify-section/pyramid_blue_lg.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__3">
        <img
          :src="require('@/assets/image/spotify-section/pyramid_blue_sm.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__4">
        <img
          :src="require('@/assets/image/spotify-section/pyramid_green.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__5">
        <img
          :src="require('@/assets/image/spotify-section/pyramid_pink.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__6">
        <img
          :src="require('@/assets/image/spotify-section/torus_blue.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__7">
        <img
          :src="require('@/assets/image/spotify-section/torus_pink.png')"
          alt="spotify-bg"
          class="spotify-element spotify-element__8">
        <div class="spotify-element blur-block blur__1"></div>
        <div class="spotify-element blur-block blur__2"></div>
        <div class="spotify-element__logo-container">
          <img
            :src="require('@/assets/image/spotify-section/spotify-logo.png')"
            alt="spotify-logo"
            class="spotify-element__logo">
        </div>
      </div>
      <div class="about">
        <div class="about__heading">
          <span>№9</span> Spotify <br>теперь в России
        </div>
        <div class="about__text" id="firstSpotifyText">
          Летом в России наконец-то запустился музыкальный
          сервис Spotify — спустя шесть лет ожидания.
          Стратегическим партнером выступила МТС — для
          наших клиентов бесплатный промопериод в сервисе
          в 2 раза длиннее. По месяцу за каждый год ожидания Spotify
        </div>
        <div class="about__text" id="secondSpotifyText">
          Листай до конца, чтобы узнать, как получить
          6 месяцев бесплатно в нашем письме
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'v-spotify-section',
  mounted() {
    const timelineSpotify = gsap.timeline({
      scrollTrigger: {
        trigger: '.spotify-section',
        start: '-70%',
        end: 'bottom',
        scrub: 2,
        onUpdate: (self) => {
          console.log('progress3:', self.progress);
          const spotifyBg = document.getElementById('spotifyBg');
          const firstSpotifyText = document.getElementById('firstSpotifyText');
          const secondSpotifyText = document.getElementById('secondSpotifyText');
          if (self.progress > 0.2) {
            if (spotifyBg.classList.contains('active')) {
              if (self.progress < 0.5 && !secondSpotifyText.classList.contains('active')) {
                return;
              }
              if (self.progress < 0.5 && self.direction === -1) {
                spotifyBg.classList.remove('active__2');
                secondSpotifyText.classList.remove('active');
                TweenMax.to('#firstSpotifyText', {
                  opacity: 1,
                  position: 'absolute',
                });
                TweenMax.to('#secondSpotifyText', {
                  opacity: 0,
                  position: 'absolute',
                });
                TweenMax.to('.spotify-section .about', {
                  y: '0',
                });
                TweenMax.to('.spotify-element__logo-container', {
                  rotate: '-0deg',
                  x: '0%',
                  y: '0%',
                  top: '0',
                  right: 'unset',
                  position: 'absolute',
                  scale: 0.6,
                });
                TweenMax.to('.spotify-element:nth-child(2n)', {
                  x: 0,
                  y: 0,
                });
                TweenMax.to('.spotify-element', {
                  x: 0,
                  y: 0,
                });
                TweenMax.to('.spotify-element__3', {
                  x: 0,
                  y: 0,
                  scale: 1,
                  rotate: '0deg',
                });
                TweenMax.to('.spotify-element__1', {
                  x: 0,
                  y: 0,
                  scale: 1,
                  rotate: '0deg',
                });
                TweenMax.to('.spotify-element__6', {
                  left: 'unset',
                  right: '4vw',
                  bottom: 'unset',
                  top: '230px',
                  x: 0,
                  y: 0,
                  scale: 1,
                  rotate: '0deg',
                });
                return;
              }
              if (self.progress > 0.5 && !spotifyBg.classList.contains('active__2') && self.direction === 1) {
                spotifyBg.classList.add('active__2');
                TweenMax.to('.spotify-section .container', {
                  overflow: 'hidden',
                });
                TweenMax.to('.spotify-element__logo-container', {
                  rotate: '-90deg',
                  x: '0%',
                  y: '0%',
                  top: '-215px',
                  right: '-215px',
                  position: 'fixed',
                  scale: 1.3,
                });
                TweenMax.to('.spotify-section .about', {
                  y: '-80px',
                });
                TweenMax.to('.spotify-element:nth-child(2n)', {
                  x: 500,
                  y: 300,
                });
                TweenMax.to('.spotify-element', {
                  x: -500,
                  y: 300,
                });
                TweenMax.to('.spotify-element__3', {
                  x: 20,
                  y: 210,
                  scale: 2.5,
                  rotate: '-60deg',
                });
                TweenMax.to('.spotify-element__1', {
                  x: 130,
                  y: 240,
                  scale: 2.5,
                  rotate: '-60deg',
                });
                TweenMax.to('.spotify-element__6', {
                  left: -30,
                  right: 'unset',
                  bottom: 'unset',
                  top: 0,
                  x: 0,
                  y: 70,
                  scale: 2.5,
                  rotate: '60deg',
                });
                return;
              }
              if (self.progress > 0.75 && spotifyBg.classList.contains('active__2') && self.direction === 1) {
                spotifyBg.classList.add('active__3');
                TweenMax.to('.spotify-section .about', {
                  y: '-50%',
                  opacity: 0,
                });
                TweenMax.to('.spotify-element', {
                  y: '-50%',
                  opacity: 0,
                });
                document.body.style.background = '#001424';
              }
              if (self.progress < 0.75 && spotifyBg.classList.contains('active__3') && self.direction === -1) {
                spotifyBg.classList.remove('active__3');
                TweenMax.to('.spotify-section .about', {
                  y: '-80px',
                  opacity: 1,
                });
                TweenMax.to('.spotify-element:nth-child(2n)', {
                  x: 500,
                  y: 300,
                });
                TweenMax.to('.spotify-element', {
                  x: -500,
                  y: 300,
                  opacity: 1,
                });
                TweenMax.to('.spotify-element__3', {
                  x: 20,
                  y: 210,
                  scale: 2.5,
                  rotate: '-60deg',
                });
                TweenMax.to('.spotify-element__1', {
                  x: 130,
                  y: 240,
                  scale: 2.5,
                  rotate: '-60deg',
                });
                TweenMax.to('.spotify-element__6', {
                  left: -30,
                  right: 'unset',
                  bottom: 'unset',
                  top: 0,
                  x: 0,
                  y: 70,
                  scale: 2.5,
                  rotate: '60deg',
                });
                TweenMax.to('.spotify-element__logo-container', {
                  opacity: 1,
                });
                document.body.style.background = '#F4F4F4';
                return;
              }
              if (self.progress === 1) {
                TweenMax.to('.spotify-element__logo-container', {
                  opacity: 0,
                });
              }
              firstSpotifyText.classList.add('hidden');
              secondSpotifyText.classList.add('active');
              TweenMax.to('#firstSpotifyText', {
                opacity: 0,
                position: 'absolute',
              });
              TweenMax.to('#secondSpotifyText', {
                opacity: 1,
                position: 'absolute',
              });
              TweenMax.to('.screen-text', {
                duration: 1,
                scale: 1.2,
              });
              return;
            }
            spotifyBg.classList.add('active');
            TweenMax.to('.spotify-element__logo', {
              opacity: 1,
            });
            TweenMax.to('.spotify-element__logo-container', {
              scale: 0.6,
            });
            TweenMax.fromTo('.spotify-element:nth-child(2n)', {
              x: 300,
              y: 200,
            }, {
              x: 0,
              y: 0,
              duration: 1,
            });
            TweenMax.fromTo('.spotify-element:nth-child(2n+1)', {
              x: -300,
              y: 100,
            }, {
              x: 0,
              y: 0,
              duration: 1,
            });
            TweenMax.fromTo('.spotify-element:nth-child(2n+3)', {
              x: -100,
              y: 400,
            }, {
              x: 0,
              y: 0,
              duration: 1,
            });
            TweenMax.fromTo('.spotify-element:nth-child(2n+4)', {
              x: 100,
              y: 500,
            }, {
              x: 0,
              y: 0,
              duration: 1,
            });
          } else {
            spotifyBg.classList.remove('active');
            spotifyBg.classList.remove('active__2');
            firstSpotifyText.classList.remove('hidden');
            secondSpotifyText.classList.remove('active');
            TweenMax.to('.spotify-element__logo', {
              duration: 0,
              opacity: 0,
            });
            TweenMax.to('.spotify-element__logo-container', {
              scale: 1,
            });
            TweenMax.to('#secondSpotifyText', {
              opacity: 0,
              position: 'absolute',
            });
            TweenMax.to('#firstSpotifyText', {
              opacity: 1,
              position: 'absolute',
            });
            TweenMax.to('.spotify-element', {
              x: 300,
              y: 200,
              duration: 1,
            });
          }
        },
      },
    });
    timelineSpotify.addLabel('start');
  },
};
</script>

<style lang="scss">
.spotify-section{
  margin-top: -50px;
  height: 1300px;

  .container{
    overflow: hidden;
    position: sticky;
    top: 0;
    display: block;
  }
  .about{
    padding-top: 335px;
    min-height: 640px;

    &__text{
      max-width: calc(100% - 30px);
    }
  }
}

.spotify-bg{
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media(max-width: 350px){
      transform: translate(0, -90px) scale(0.8);
  }
}

.spotify-element__logo-container{
  position: absolute;
  top: 0;
  width: 100%;
  max-width: 410px;
  height: 100vw;
  max-height: 410px;
  border-radius: 50%;
  background-color: #ffffff;
}
.spotify-element__logo{
  position: absolute;
  top: 0;
  width: 100%;
}

.spotify-element{
  position: absolute;

  &__1{
    top: 295px;
    left: 38vw;
    width: 34px;
    height: 34px;
  }

  &__2{
    left: 35vw;
    top: 10px;
    width: 26px;
    height: 26px;
  }

  &__3{
    left: 0;
    top: 220px;
    width: 148px;
    height: 148px;
  }

  &__4{
    left: 7vw;
    top: 40px;
    width: 44px;
    height: 44px;
  }

  &__5{
    right: 1vw;
    top: 0;
    width: 100px;
    height: 100px;
  }

  &__6{
    right: 4vw;
    top: 230px;
    width: 100px;
    height: 100px;
  }

  &__7{
    right: 3vw;
    top: 130px;
    width: 53px;
    height: 53px;
  }

  &__8{
    left: 3vw;
    top: 160px;
    width: 45px;
    height: 45px;
  }
}

.blur-block{
  z-index: 5;
  background: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(4px);
  border-radius: 200px;

  &.blur__1{
    top: 40px;
    left: 10vw;
    width: 86px;
    height: 86px;
    transform: matrix(0.17, -0.97, -1.01, 0.09, 0, 0);
  }

  &.blur__2{
    top: 210px;
    right: 13vw;
    width: 96px;
    height: 96px;
    transform: matrix(0.17, -0.97, -1.01, 0.09, 0, 0);
  }
}

@media(min-width: 500px){

  .spotify-section .about{
    padding-top: 360px;
  }
}
@media(max-width: 360px) {
  .spotify-section {
    margin-top: 30px;
  }
  .spotify-section .about {
    padding-top: 230px;
    z-index: 50;
    position: relative;
  }
}
@media(max-width: 400px) and (max-height: 670px){
  .spotify-section {
    margin-top: 10px;
  }
}
@media(max-width: 400px) and (max-height: 610px){
  .spotify-section {
    margin-top: 110px;
    .about__heading{
      margin-bottom: 10px;
    }
    .about__text{
      line-height: 1.4;
    }
  }
}
</style>
